import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import titleMixin from "./mixins/titleMixin";
// import { budgetService } from "./services/index";
// console.log("BUDGET SVC", budgetService);

// Import the Auth0 configuration
import auth0Config from "../auth_config.json";

// Runtime hostname → service URL resolver (custom domains + primary domains)
import hostConfig from "./config/hostResolver";

// Import the  Auth0 plugin here
import { Auth0Plugin } from "./auth";

import vuetify from "./plugins/vuetify";

//Imports component for telephone numbers
import VueTelInputVuetify from "vue-tel-input-vuetify/lib";
// import VueAuthImage from "vue-auth-image";

// Used for mobile detection to link to app store
import VueMobileDetection from "vue-mobile-detection";

// Loading screen for window.open
// const open = window.open.bind(window);
// window.open = function (url, name, features) {
//   /**
//    * @type {Window}
//    */
//   const w = open('about:blank', name, features);
//   w.document.body.innerHTML = `<div style='
//   background: linear-gradient(45deg,#a1d76e 1%,#0aaceb),#fff;
//   background-size: 100% 100%,100%;
//   background-repeat: no-repeat;
//   background-position: bottom,top;
//           color: white;
//           font-family: Avenir,Helvetica,Arial,sans-serif;
//           width: 100vw;
//           height: 100vh;
//           display: flex;
//           justify-content: center;
//           align-items: center;
//         '><strong style='
//           flex: 0 0 120px;'><em>Loading...</em></strong></div>`
//   w.document.body.style.margin = '0'
//   w.location = url;

//   return w;
// }
//used for google analytics and event tagging
import VueGtag from "vue-gtag";
Vue.use(
  VueGtag,
  {
    config: {
      id: process.env.VUE_APP_GOOGLE_TAG_MANAGER,
    },
    includes: [{ id: process.env.VUE_APP_GOOGLE_ANALYTICS }],
  },
  router
);

import VueApexCharts from "vue-apexcharts";
Vue.use(VueApexCharts);

Vue.component("apexchart", VueApexCharts);

// Install the authentication plugin here
// hostConfig.authDomain is derived at runtime from the browser hostname;
// falls back to auth_config.json when running locally (authDomain === null).
Vue.use(Auth0Plugin, {
  domain: hostConfig.authDomain || auth0Config.domain,
  clientId: auth0Config.clientId,
  audience: auth0Config.audience,
  store,
  onRedirectCallback: (appState) => {
    // Prefer explicit target; fall back to "/" (pathname is often already "/"
    // on callback, and push("/") can no-op while leaving #access_token=...).
    const target = appState && appState.targetUrl ? appState.targetUrl : "/";
    if (window.location.hash && window.location.hash.includes("access_token=")) {
      window.history.replaceState(
        window.history.state || {},
        document.title,
        window.location.pathname + window.location.search
      );
    }
    router.push(target).catch(() => {});
  },
});

Vue.use(VueTelInputVuetify, {
  vuetify,
});

import VideoPlayer from "vue-video-player";
require("./css/video-js.css");
require("vue-video-player/src/custom-theme.css");
// import VideoPlayer from "@videojs-player/vue";
// import "video.js/dist/video-js.css";
// const hls = require("videojs-contrib-hls");
// Vue.use(hls);
Vue.use(VideoPlayer);

Vue.use(VueMobileDetection);

// Vue.use(VueAuthImage);

// Cover the gap between index.html and the first titled component mounting
// (ADO #187152). The HTML <title> is already Loading...; this pins it again
// in case a plugin or import touched document.title during boot.
document.title = "Loading...";

Vue.mixin(titleMixin);

// ── Vue 3 lifecycle-name compatibility shim ──────────────────────────────────
// Our eslint rule (`vue/no-deprecated-destroyed-lifecycle`) autofixes Options
// `destroyed`/`beforeDestroy` to the Vue 3 names `unmounted`/`beforeUnmount`,
// but Vue 2.7's Options API never calls those names — so the renamed hooks
// silently never run (leaking listeners/timers/subscriptions). This shim makes
// 2.7 invoke them, mirroring how @vue/compat aliases the old names.
//
// REMOVE THIS at the Vue 3 core switch — Vue 3 calls these natively and the
// shim would double-fire them.
Vue.config.optionMergeStrategies.beforeUnmount = Vue.config.optionMergeStrategies.beforeDestroy;
Vue.config.optionMergeStrategies.unmounted = Vue.config.optionMergeStrategies.destroyed;
Vue.mixin({
  // The shim must use the *native* 2.7 hooks; never let the autofix rename these
  // (doing so would break the very mechanism that makes the new names fire).
  // eslint-disable-next-line vue/no-deprecated-destroyed-lifecycle
  beforeDestroy() {
    const hooks = this.$options.beforeUnmount;
    if (hooks) hooks.forEach((fn) => fn.call(this));
  },
  // eslint-disable-next-line vue/no-deprecated-destroyed-lifecycle
  destroyed() {
    const hooks = this.$options.unmounted;
    if (hooks) hooks.forEach((fn) => fn.call(this));
  },
});
// ─────────────────────────────────────────────────────────────────────────────

Vue.config.productionTip = false;

// Option: Make API services globally available on the Vue instance
// Vue.prototype.$apiBudget = budgetService;

if (process.env.VUE_APP_ENVIRONMENT == "prod") Vue.config.devtools = false;

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
